import { useCallback, useMemo } from 'react';

import FilterBarComponent from 'components/shared/filters/FilterBar';
import { createGroupTypeDropdown } from 'constants/filterConfigs';
import { useProfile } from 'context/profile';
import { usePreferredProvidersActions, usePreferredProvidersStore } from 'stores/preferredProvidersStore';

import { selectablePreferredProviderTypes } from './helpers';

const FilterBar = () => {
  const { profile } = useProfile();
  const filters = usePreferredProvidersStore((state) => state.filters);
  const { setFilters, setSearch } = usePreferredProvidersActions();

  // One provider picker per selectable type, limited to the client's network, matching what can be on
  // a list. viewOnly so provider-only users get the client's whole network, not just their own groups'.
  const filterSections = useMemo(
    () => [
      {
        title: 'Preferred Providers',
        filters: selectablePreferredProviderTypes(profile).map((type) =>
          createGroupTypeDropdown(type, { networkClientId: profile.actingClient.id, viewOnly: true })
        ),
      },
    ],
    [profile]
  );

  const handleApplyFilters = useCallback(
    ({ search, ...nextFilters }) => {
      setFilters(nextFilters);
      setSearch(search);
    },
    [setFilters, setSearch]
  );

  return (
    <FilterBarComponent
      showSearchInput={true}
      searchPlaceholder='Search Location'
      applyFilters={handleApplyFilters}
      filters={filters}
      filterSections={filterSections}
      onClearFilters={() => setFilters({})}
      showResults={false}
      title='Preferred Providers'
    />
  );
};

export default FilterBar;
